/**
 * @module
 *
 * @todo
 *
 *   - Reactive {@link PasswordRestore.token}
 *   - Reactive {@link PasswordRestore.email}
 */

import {globalValue} from '@acng/frontend-relativity';
import {guard, INTERFACE, IS_INPUT, NULLABLE} from '@acng/frontend-rubicon';
import {popup} from '@acng/frontend-discovery';
import {FormController, setPasswordInput} from 'nova';
/** @import {FormArrangement, SubmitAction} from 'nova' */

import {post} from '../../core/service/backend.js';
import {main} from '../../core/service/location.js';
import {getLocalOverlay} from '../../core/service/overlay.js';
import {ctxSearchParams} from '../../core/context/search-params.js';
import {t} from '../../locale/config/translate.js';
import {user} from '../user.js';
import {AUTH_USER_DATA} from '../model/user-data.js';
import {performLogin} from '../auth/login.js';
import {reactive} from 'nova';

class Credentials {
  @reactive accessor token = '';
  @reactive accessor email = '';
}

/**
 * Password Restore Form
 *
 * The user does not have to be authenticated to use this form.
 */
class PasswordRestore extends FormController {
  magic = new Credentials();

  /**
   * @type {FormArrangement}
   *
   * @override
   */
  arrange(form) {
    ASSERT: {
      const FIELDS = INTERFACE({
        password: IS_INPUT,
        password_confirmation: IS_INPUT,
      });

      guard(form.elements, FIELDS);
    }

    const {password, password_confirmation} = form.elements;
    setPasswordInput(password);
    setPasswordInput(password_confirmation);
  }

  /**
   * @override
   */
  upgrade() {
    this.magic.token = `${main.globals.passwordReset || user.password_reset_token}`;
    this.magic.email = globalValue(ctxSearchParams).get('email') ?? user.email;
  }

  /**
   * @type {SubmitAction}
   *
   * @override
   */
  async submit(form, data) {
    data.set('token', `${this.magic.token}`);
    data.set('email', `${this.magic.email}`);
    const userData = await post('user/reset-password', data, form);
    ASSERT: guard(userData, NULLABLE(AUTH_USER_DATA));

    await popup(form).info(await t('userPool.changedPassword'));

    if (!userData) {
      // 2fa
      return;
    }

    const overlay = getLocalOverlay(form);

    if (overlay) {
      overlay.close();
    } else {
      userData.redirectPath ??= '/';
    }

    performLogin(userData);
  }
}

export {PasswordRestore};
